import AppForm from '../app-components/Form/AppForm';

Vue.component('work-day-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                employee_contract_id:  '' ,
                is_locked:  false ,
                is_hidden:  false ,
                is_active_version:  false ,
                date:  '' ,
                
            }
        }
    }

});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/work-day/Form.js